<script lang="ts">
  import { CommonDto } from '@do/data-transfer-objects';
  import { ArtistStatus } from '@do/models';
  import { DirectusImage, Preset } from '@do/svelte-directus-images';

  import { Content } from '@shared/ui/content';
  import type { FaqBlock } from '@shared/ui/faq';
  import { ReadMore } from '@shared/ui/read-more';
  import { cn } from '@shared/utils';

  export let name: string;
  export let description: FaqBlock[] | undefined = undefined;
  export let photo: CommonDto.Photo | undefined = undefined;
  export let dateOfBirth: string | null = null;
  export let countries = '';
  export let slug: string | null = null;
  export let status: ArtistStatus;
  export let id: number;

  $: isArtistPublished = status === ArtistStatus.Published;
</script>

<div class="flex w-full flex-col items-start gap-6 xl:gap-10">
  <svelte:element
    this="{isArtistPublished ? 'a' : 'div'}"
    href="/artist-{id}-{slug}/"
    class="flex shrink-0 items-center justify-center gap-5"
  >
    <div class="shrink-0">
      <DirectusImage
        imageData="{photo}"
        alt="{name}"
        pictureSizes="{{
          default: '200px',
        }}"
        imgClasses="h-24 w-24 shrink-0 overflow-hidden rounded-full object-cover"
        presetKeys="{Preset.Thumbnail}"
        loading="lazy"
      />
    </div>

    <div>
      <svelte:element
        this="{isArtistPublished ? 'a' : 'p'}"
        href="/artist-{id}-{slug}/"
        class="{cn('mb-5 block text-center text-3xl font-medium md:text-start xl:mb-0', {
          'hover:text-default-500 transiiton-colors': isArtistPublished,
        })}"
      >
        {name}
      </svelte:element>

      {#if dateOfBirth}
        <p class="inline-block text-sm">
          Born {new Date(dateOfBirth).getFullYear()}{#if countries},{/if}
        </p>
      {/if}

      {#if countries}
        <p class="inline-block text-sm">{countries}</p>
      {/if}
    </div>
  </svelte:element>

  <div>
    <ReadMore collapseHeight="{120}" readMoreText="Show more" readLessText="Show less">
      <Content blocks="{description}" containerClasses="text-base md:text-base" />
    </ReadMore>
  </div>
</div>
